import {IAutoOrderOrder} from '../../auto-ordering/models';
import {INotification} from './notification';

//#region INTERFACE IUserSelectedNotification
/**
 * ### IUserSelectedNotification
 * Represents a user's selected notification with related domain data.
 *
 * @interface IUserSelectedNotification
 * @extends Object
 * @description Groups notification metadata with associated auto order and stock update info.
 *
 * @example
 * const selectedNotification: IUserSelectedNotification = {
 *   autoOrder: someAutoOrderObject,
 *   notification: someNotification,
 *   stockUpdate: "Updated stock information"
 * };
 */
export interface IUserSelectedNotification extends Object {
  /**
   * The auto order associated with the notification.
   *
   * @type {IAutoOrderOrder}
   */
  autoOrder: IAutoOrderOrder;

  /**
   * The notification metadata and content.
   *
   * @type {INotification}
   */
  notification: INotification;

  /**
   * A string representing the stock update related to the notification.
   *
   * @type {string}
   */
  stockUpdate: string;
}

//#endregion
